window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.preApprovedForCohortBox = window.locales.am.preApprovedForCohortBox || {};window.locales.am.preApprovedForCohortBox = {...window.locales.am.preApprovedForCohortBox, ...{
    "title": "አስፈፃሚ የትምህርት ፕሮግራሞች",
    "content": "በፍላጎትዎ እና በተሞክሮዎ መሰረት፣ ለአዲስ የኳንቲክ ሰርተፊኬቶች ለመመዝገብ ብቁ ነዎት።",
    "ai_and_future_of_business": "AI እና የወደፊት የንግድ ፕሮግራሞች",
    "data_and_finance": "የውሂብ እና የፋይናንስ ፕሮግራሞች",
    "rise_to_c_suite": "ወደ C-Suite ፕሮግራሞች ይነሱ",
    "review_and_register": "ይገምግሙ እና ይመዝገቡ",
    "mobileTitle": "አዲስ! አስፈፃሚ ትምህርት"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.preApprovedForCohortBox = window.locales.ar.preApprovedForCohortBox || {};window.locales.ar.preApprovedForCohortBox = {...window.locales.ar.preApprovedForCohortBox, ...{
    "title": "برامج التعليم التنفيذي",
    "content": "بناءً على اهتماماتك وخبراتك، فأنت مؤهل للتسجيل في شهادات Quantic الجديدة.",
    "ai_and_future_of_business": "برامج الذكاء الاصطناعي ومستقبل الأعمال",
    "data_and_finance": "برامج البيانات والمالية",
    "rise_to_c_suite": "برامج الارتقاء إلى المناصب العليا",
    "review_and_register": "المراجعة والتسجيل",
    "mobileTitle": "جديد! التعليم التنفيذي"
}
};window.locales.en = window.locales.en || {};window.locales.en.preApprovedForCohortBox = window.locales.en.preApprovedForCohortBox || {};window.locales.en.preApprovedForCohortBox = {...window.locales.en.preApprovedForCohortBox, ...{
    "title": "Executive Education Programs",
    "content": "Based on your interests and experience, you are eligible to enroll in new Quantic certificates.",
    "ai_and_future_of_business": "AI & Future of Business Programs",
    "data_and_finance": "Data & Finance Programs",
    "rise_to_c_suite": "Rise to the C-Suite Programs",
    "review_and_register": "Review and Register",
    "mobileTitle": "New! Executive Education"
}
};window.locales.es = window.locales.es || {};window.locales.es.preApprovedForCohortBox = window.locales.es.preApprovedForCohortBox || {};window.locales.es.preApprovedForCohortBox = {...window.locales.es.preApprovedForCohortBox, ...{
    "title": "Programas de educación ejecutiva",
    "content": "Según sus intereses y experiencia, usted es elegible para inscribirse en nuevos certificados Quantic.",
    "ai_and_future_of_business": "Programas de IA y el futuro de los negocios",
    "data_and_finance": "Programas de datos y finanzas",
    "rise_to_c_suite": "Programas de ascenso a la alta dirección",
    "review_and_register": "Revisar y Registrarse",
    "mobileTitle": "¡Nuevo! Educación ejecutiva"
}
};window.locales.it = window.locales.it || {};window.locales.it.preApprovedForCohortBox = window.locales.it.preApprovedForCohortBox || {};window.locales.it.preApprovedForCohortBox = {...window.locales.it.preApprovedForCohortBox, ...{
    "title": "Programmi di formazione per dirigenti",
    "content": "In base ai tuoi interessi e alla tua esperienza, potresti essere idoneo a iscriverti a nuovi certificati Quantic.",
    "ai_and_future_of_business": "Programmi di intelligenza artificiale e futuro aziendale",
    "data_and_finance": "Programmi di dati e finanza",
    "rise_to_c_suite": "Programmi per raggiungere i vertici aziendali",
    "review_and_register": "Revisione e registrazione",
    "mobileTitle": "Novità! Formazione Executive"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.preApprovedForCohortBox = window.locales.zh.preApprovedForCohortBox || {};window.locales.zh.preApprovedForCohortBox = {...window.locales.zh.preApprovedForCohortBox, ...{
    "title": "高管教育项目",
    "content": "根据您的兴趣和经验，您有资格注册新的 Quantic 证书。",
    "ai_and_future_of_business": "人工智能与未来商业计划",
    "data_and_finance": "数据与财务计划",
    "rise_to_c_suite": "晋升至高管计划",
    "review_and_register": "审核并注册",
    "mobileTitle": "全新！高管教育"
}
};